import React, { useState } from 'react';
import { DropdownMenu } from './DropDownMenu';
import { MenuTrigger } from './MenuTrigger';
import { LocalizationType } from 'types/translations.types';
import { useTranslation } from 'react-i18next';
import { LOCALE } from 'utils/constants';
import { Check, Languages } from 'lucide-react';

interface Language {
	code: LocalizationType;
	label: string;
	icon?: string;
}

const LANGUAGES: Language[] = [
	{ code: LocalizationType.RU, label: 'Русский' },
	{ code: LocalizationType.KK, label: 'Қазақша' },
	{ code: LocalizationType.EN, label: 'English' }
];

export const LanguageSelector: React.FC = () => {
	const { i18n } = useTranslation();
	const [isOpen, setIsOpen] = useState(false);

	// const currentLanguage = LANGUAGES.find(lang => lang.code === i18n.language);

	const changeLanguage = (code: LocalizationType) => {
		localStorage.setItem(LOCALE, code);
		i18n.changeLanguage(code);
		setIsOpen(false);
		window.location.reload();
	};

	return (
		<DropdownMenu isOpen={isOpen} setIsOpen={setIsOpen}>
			<MenuTrigger
				isOpen={isOpen}
				onClick={() => setIsOpen(!isOpen)}
				icon={<Languages className='h-5 w-5 text-blue-600' />}
				// label={currentLanguage?.label}
			/>

			{isOpen && (
				<div className='absolute right-0 mt-2 w-48 rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5'>
					{LANGUAGES.map(language => (
						<button
							key={language.code}
							onClick={() => changeLanguage(language.code)}
							className={`flex w-full items-center px-4 py-2 text-sm hover:bg-gray-100 ${language.code === i18n.language ? 'bg-gray-50 text-blue-600' : 'text-gray-700'}`}
						>
							{language.label}
							{language.code === i18n.language && (
								<Check className='ml-auto h-4 w-4' />
							)}
						</button>
					))}
				</div>
			)}
		</DropdownMenu>
	);
};
